import { convertDateArrayFromDate, convertDateFromDateArray, } from '@starjack/utils';
import { convertStarjackDateRangeToFrontend, Gender, } from '@starjack/utils';
import { v4 as uuid } from 'uuid';
export const convertOrderTicketToFrontend = (p) => ({
    ...p,
    startDay: convertDateFromDateArray(p.startDay),
    validity: convertStarjackDateRangeToFrontend(p.validity),
    issueValidity: convertStarjackDateRangeToFrontend(p.issueValidity),
    persons: p.persons.map((person) => ({
        ...person,
        ...(!!person.birthday && {
            birthday: convertStarjackDateRangeToFrontend(person.birthday),
        }),
    })),
});
export const createTicketHolder = ({ ticketId, }) => ({
    id: uuid(),
    gender: null,
    firstname: '',
    lastname: '',
    birthDay: null,
    ticketId,
});
export const getAllOrderTicketsFromCollection = (ticketCollection) => Object.values(ticketCollection.ticketMap);
/**
 * Creates a unique ID for an OrderTicketCollection based on name and startDay
 */
export const createOrderTicketCollectionId = (name, startDay) => {
    const formatDate = (date) => {
        if (!date)
            return '';
        try {
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const day = String(date.getDate()).padStart(2, '0');
            return `${day}.${month}.${year}`;
        }
        catch {
            return '';
        }
    };
    return `${name}_${formatDate(startDay)}`;
};
export const groupOrderTicketsByTicketName = (tickets) => {
    const ticketCollectionMap = tickets.reduce((collectionContainer, currentTicket) => {
        const collectionId = createOrderTicketCollectionId(currentTicket.name.de, currentTicket.startDay);
        if (collectionContainer[collectionId]) {
            const ticketCollection = collectionContainer[collectionId];
            collectionContainer[collectionId] = {
                ...ticketCollection,
                ticketMap: {
                    ...ticketCollection.ticketMap,
                    [currentTicket.productId]: currentTicket,
                },
                ticketHoldersMap: {
                    ...ticketCollection.ticketHoldersMap,
                    [currentTicket.productId]: [],
                },
            };
        }
        else {
            collectionContainer[collectionId] = {
                id: collectionId,
                name: currentTicket.name,
                duration: currentTicket.duration,
                type: currentTicket.type,
                startDay: currentTicket.startDay,
                validity: currentTicket.validity,
                filterTags: currentTicket.filterTags,
                infoText: currentTicket.infoText,
                photoRequired: currentTicket.photoRequired,
                sortKey: currentTicket.sortKey,
                numberOfTicketHolders: 0,
                ticketMap: {
                    [currentTicket.productId]: currentTicket,
                },
                ticketHoldersMap: {
                    [currentTicket.productId]: [],
                },
            };
        }
        return collectionContainer;
    }, {});
    return Object.values(ticketCollectionMap);
};
export const addTicketHolderToTicket = ({ ticketCollection, ticketHolder, }) => ({
    ...ticketCollection,
    id: ticketCollection.id, // Preserve id
    numberOfTicketHolders: ticketCollection.numberOfTicketHolders + 1,
    ticketHoldersMap: {
        ...ticketCollection.ticketHoldersMap,
        [ticketHolder.ticketId]: [
            ...ticketCollection.ticketHoldersMap[ticketHolder.ticketId],
            ticketHolder,
        ],
    },
});
export const removeTicketHolder = (params) => {
    const { ticketCollection, ticketHolder } = params;
    const currentTicketHolders = ticketCollection.ticketHoldersMap[ticketHolder.ticketId];
    return {
        ...ticketCollection,
        id: ticketCollection.id, // Preserve id
        numberOfTicketHolders: ticketCollection.numberOfTicketHolders - 1,
        ticketHoldersMap: {
            ...ticketCollection.ticketHoldersMap,
            [ticketHolder.ticketId]: currentTicketHolders.filter((cTH) => cTH.id !== ticketHolder.id),
        },
    };
};
export const getPriceTotalFromTicketCollection = (ticketCollection) => {
    return Object.values(ticketCollection.ticketHoldersMap).reduce((collectionTotal, ticketHolders) => {
        return ticketHolders.reduce((ticketTotal, ticketHolder) => {
            return {
                amount: ticketTotal.amount +
                    ticketCollection.ticketMap[ticketHolder.ticketId].price
                        .amount,
                currency: ticketTotal.currency,
            };
        }, collectionTotal);
    }, { amount: 0, currency: 'EUR' });
};
export const createSubmitOrderTicketsFromTicketCollection = (ticketCollection, liftOperator, confirmationNumber = '') => {
    return Object.values(ticketCollection.ticketHoldersMap).reduce((tickets, ticketHolders) => {
        ticketHolders.forEach((ticketHolder) => {
            tickets.push({
                confirmationNumber,
                identifications: [{ id: `@${ticketHolder.id}` }],
                liftOperator: liftOperator.id,
                price: ticketCollection.ticketMap[ticketHolder.ticketId].price,
                productId: ticketHolder.ticketId,
                startDate: convertDateArrayFromDate(ticketCollection.ticketMap[ticketHolder.ticketId].startDay),
                priceCode: null,
                discounts: [],
            });
        });
        return tickets;
    }, []);
};
export const createSubmitOrderIdentificationFromTicketCollection = (ticketCollection, liftOperator) => {
    return Object.values(ticketCollection.ticketHoldersMap).reduce((tickets, ticketHolders) => {
        ticketHolders.forEach((ticketHolder) => {
            tickets.push({
                ref: ticketHolder.id,
                firstname: ticketHolder.firstname,
                lastname: ticketHolder.lastname,
                birthday: convertDateArrayFromDate(ticketHolder.birthDay),
                type: 'PICKUP',
                depositAmount: liftOperator.pickupDepositAmount,
                image: null,
                price: {
                    amount: 0,
                    currency: 'EUR',
                },
                title: '-',
                gender: Gender.MALE,
                cardType: '',
            });
        });
        return tickets;
    }, []);
};
